// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const Close = createIcon(
  <path
    clipRule="evenodd"
    d="M8.39382 7.62103C8.04235 7.26955 7.4725 7.26955 7.12103 7.62103C6.76955 7.9725 6.76955 8.54235 7.12103 8.89382L10.7273 12.5001L7.1211 16.1063C6.76962 16.4578 6.76962 17.0276 7.1211 17.3791C7.47257 17.7306 8.04242 17.7306 8.39389 17.3791L12.0001 13.7729L15.6063 17.3791C15.9578 17.7306 16.5276 17.7306 16.8791 17.3791C17.2306 17.0276 17.2306 16.4578 16.8791 16.1063L13.2729 12.5001L16.8792 8.89382C17.2306 8.54235 17.2306 7.9725 16.8792 7.62103C16.5277 7.26955 15.9578 7.26955 15.6064 7.62103L12.0001 11.2273L8.39382 7.62103Z"
    fillRule="evenodd"
  />,
);
